import React, { useState, useEffect } from "react";
import { connect, useSelector } from "react-redux";
import {
    TextField,
    Button,
    Grid,
    Card,
    CardContent,
    Typography,
} from "@material-ui/core";
import { setLoading, setSnackInfo } from "../../redux/actions/appAction";
import HttpService from "../../services/httpService";

const FurnitureoneSettings = (props) => {
    const { userDetails } = useSelector((state) => state.user);

    const [items, setItems] = useState([]);
        const getFurnitureItems = async () => {
        try {
            props.setLoading(true);

            const response = await HttpService.getFurnitureItems();
            // while setting API data
            if (response?.data?.success) {
                const updatedData = (response.data.data || []).map((el) => ({
                    ...el,
                    saved_image_url_erp: el.image_url_erp || "",
                }));

                setItems(updatedData);
            }
        } catch (error) {
            props.setSnackInfo(
                error?.response?.data?.message || "Something went wrong",
                "error"
            );
        } finally {
            props.setLoading(false);
        }
    };

    const updateImageUrl = async (itemId, image_url_erp) => {
        try {
            props.setLoading(true);

            const response = await HttpService.updateFurnitureOneItems({ itemId, image_url_erp });

            if (response?.data?.success) {
                props.setSnackInfo("Image URL updated successfully", "success");

                getFurnitureItems();
            }
        } catch (error) {
            props.setSnackInfo(
                error?.response?.data?.message || "Something went wrong",
                "error"
            );
        } finally {
            props.setLoading(false);
        }
    };

    const handleChange = (index, value) => {
        const temp = [...items];
        temp[index].image_url_erp = value;
        setItems(temp);
    };

    useEffect(() => {
        getFurnitureItems();
    }, []);

      const navigateToItemDetail = (item) => {
        const url = `/furniture-one-item-details?itemId=${item.item_id}`;
        window.open(url, "_blank");
    };
    return (
        <div style={{ padding: "20px" }}>
            <Typography variant="h5" gutterBottom>
                FurnitureOne ERP Image Settings
            </Typography>

            <Grid container spacing={2}>
                {items.map((item, index) => (
                    <Grid item xs={12} md={6} lg={4} key={item._id}>
                        <Card>
                            <CardContent>
                                <Typography variant="h6">
                                    {item.item_name}
                                </Typography>

                                <Typography
                                    variant="body2"
                                    style={{ marginBottom: 10 }}
                                >
                                    Item ID : {item.item_id}
                                </Typography>

                                {/* IMAGE  */}
                                {item?.saved_image_url_erp ? (
                                    <div style={{ marginBottom: 15 }}>
                                        <img
                                            src={item.saved_image_url_erp}
                                            alt={item.item_name}
                                            onClick={() => navigateToItemDetail(item)}
                                            style={{
                                                width: "100px",
                                                height: "100px",
                                                objectFit: "cover",
                                                borderRadius: "8px",
                                                border: "1px solid #ccc",
                                                marginBottom: "8px",
                                                cursor: "pointer",
                                                transition: "transform 0.2s ease",
                                            }}
                                        />

                                        <Typography
                                            variant="body2"
                                            style={{
                                                wordBreak: "break-all",
                                                color: "#1976d2",
                                                marginBottom: "8px",
                                            }}
                                        >
                                            <a
                                                href={item.saved_image_url_erp}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                View Image Link
                                            </a>
                                        </Typography>
                                    </div>
                                ) : (
                                    <Typography
                                        variant="body2"
                                        style={{
                                            color: "gray",
                                            marginBottom: 10,
                                        }}
                                    >
                                        No  Image
                                    </Typography>
                                )}

                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    label="ERP Image URL"
                                    value={item.image_url_erp || ""}
                                    onChange={(e) =>
                                        handleChange(index, e.target.value)
                                    }
                                />

                                <Button
                                    variant="contained"
                                    color="primary"
                                    style={{ marginTop: 15 }}
                                    onClick={() =>
                                        updateImageUrl(
                                            item._id,
                                            item.image_url_erp
                                        )
                                    }
                                >
                                    Update
                                </Button>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </div>
    );
};

export default connect(null, {
    setLoading,
    setSnackInfo,
})(FurnitureoneSettings);